import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import SavingStates from "../../constants/states/SavingStates";
import ProfileEditView from "../views/ProfileEditView";
import ProfileEditViewStore from "../../stores/ProfileEditViewStore";

class ProfileEditContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "profileEditViewStoreState": ProfileEditViewStore.getState()
        };
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.profileCreateViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PROFILE_EDIT_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
        EventPublisher.unsubscribe(this.profileCreateViewStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "profileEditViewStoreState": ProfileEditViewStore.getState()
        });
    };

    render() {
        return (
            <ProfileEditView
                isSaving={this.state.profileEditViewStoreState.savingState === SavingStates.SAVING}
                googleAPILibReady={this.state.googleAPILibState.loadingState === LoadingStates.FINISHED_LOADING}
                displayName={this.state.profileEditViewStoreState.displayName}
                email={this.state.profileEditViewStoreState.email}
                phoneNumber={this.state.profileEditViewStoreState.phoneNumber}
                about={this.state.profileEditViewStoreState.about}
                paymentAddressName={this.state.profileEditViewStoreState.paymentAddressName}
                currentPaymentAddressGooglePlaceId={this.state.profileEditViewStoreState.currentPaymentAddressGooglePlaceId}
                currentPaymentAddressStreetNumber={this.state.profileEditViewStoreState.currentPaymentAddressStreetNumber}
                currentPaymentAddressRoute={this.state.profileEditViewStoreState.currentPaymentAddressRoute}
                currentPaymentAddressSecondaryAddress={this.state.profileEditViewStoreState.currentPaymentAddressSecondaryAddress}
                currentPaymentAddressLocality={this.state.profileEditViewStoreState.currentPaymentAddressLocality}
                currentPaymentAddressAdministrativeAreaLevel1={this.state.profileEditViewStoreState.currentPaymentAddressAdministrativeAreaLevel1}
                currentPaymentAddressAdministrativeAreaLevel2={this.state.profileEditViewStoreState.currentPaymentAddressAdministrativeAreaLevel2}
                currentPaymentAddressCountryLong={this.state.profileEditViewStoreState.currentPaymentAddressCountryLong}
                currentPaymentAddressCountryShort={this.state.profileEditViewStoreState.currentPaymentAddressCountryShort}
                currentPaymentAddressPostalCode={this.state.profileEditViewStoreState.currentPaymentAddressPostalCode}
                formattedAddress={this.state.profileEditViewStoreState.formattedAddress}
            />
        );
    }

}

export default ProfileEditContainer;